import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { RootState } from '@whelk/store';
import { openLoginModal } from '@whelk/utils/src/login';
import { trackCustomEvent } from '@whelk/utils/src/track';
import { setShowLogoutModal } from '@whelk/store/slices/userSlice';
import { setContactPageOpen } from '@whelk/store/slices/layoutSlice';
import { setIsShareSelecting } from '@whelk/store/slices/chatListSlice';

import WebUserInfo from './Web';
import MobileUserInfo from './Mobile';

const UserInfo = () => {
  const dispatch = useDispatch();
  const isShareSelecting = useSelector((state: RootState) => state.chat.isShareSelecting);

  // 触发登录
  const onClickLogin = () => {
    openLoginModal('login_click');
  };

  // 点击联系我们
  const onClickContentUs = () => {
    if (isShareSelecting) {
      dispatch(setIsShareSelecting(false));
    }
    dispatch(setContactPageOpen(true));
    trackCustomEvent({
      id: 'avatar_drop_down_click',
      drop_down_clk_type: 'contant_us',
    });
  };

  // 触发退出登录
  const onClickLogout = () => {
    if (isShareSelecting) {
      dispatch(setIsShareSelecting(false));
    }
    dispatch(setShowLogoutModal(true));
    trackCustomEvent({ id: 'avatar_drop_down_click', drop_down_clk_type: 'sign_out' });
  };

  return (
    <>
      <div className='hidden md:block'>
        <WebUserInfo
          onClickLogin={onClickLogin}
          onClickLogout={onClickLogout}
          onClickContentUs={onClickContentUs}
        />
      </div>
      <div className='block md:hidden'>
        <MobileUserInfo
          onClickLogin={onClickLogin}
          onClickLogout={onClickLogout}
          onClickContentUs={onClickContentUs}
        />
      </div>
    </>
  );
};

export default UserInfo;
